/**
 * Converts plain text to safe HTML with clickable links and preserved newlines.
 * - Escapes HTML entities to prevent XSS
 * - Converts URLs (http/https) to clickable <a> tags
 * - Converts newlines to <br /> tags
 */
export function formatPlainTextToHtml(text: string): string {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
        .replace(/\n/g, '<br />');
}
